import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

export default function CheckoutSim() {
  const [processing, setProcessing] = useState(true);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const planId = searchParams.get('plan') || 'Aarohan Service';

  useEffect(() => {
    // Simulate network delay for fetching payment gateway details
    const timer = setTimeout(() => {
      setProcessing(false);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100vw', height: '100vh', background: '#0D0904', color: '#FAF7F0', overflow: 'hidden' }}>
      
      {/* Cinematic Background Elements */}
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '60vw', height: '60vw', background: 'radial-gradient(circle at center, rgba(200,146,42,0.05) 0%, transparent 60%)', zIndex: 0 }} />

      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        style={{ position: 'relative', zIndex: 10, background: 'rgba(26,18,9,0.7)', border: '1px solid rgba(250,247,240,0.08)', borderRadius: 2, padding: '48px', width: '100%', maxWidth: 480, backdropFilter: 'blur(16px)', boxShadow: '0 24px 64px rgba(0,0,0,0.5)', textAlign: 'center' }}
      >
        <span style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 24, letterSpacing: '4px', display: 'block', marginBottom: 32, opacity: 0.8 }}>
          A<span style={{ color: '#C8922A' }}>A</span>ROHAN
        </span>

        {processing ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }}>
            {/* Custom Spinner */}
            <div style={{ position: 'relative', width: 48, height: 48 }}>
              <motion.div animate={{ rotate: 360 }} transition={{ repeat: Infinity, duration: 1.5, ease: "linear" }} style={{ position: 'absolute', inset: 0, border: '1px solid rgba(250,247,240,0.1)', borderTopColor: '#C8922A', borderRadius: '50%' }} />
              <div style={{ position: 'absolute', inset: 8, border: '1px solid rgba(250,247,240,0.1)', borderRadius: '50%' }} />
            </div>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }}>
              <h3 style={{ fontSize: 16, fontWeight: 500, margin: '0 0 8px 0' }}>Initializing Secure Gateway...</h3>
              <p style={{ fontSize: 13, color: 'rgba(250,247,240,0.4)', margin: 0 }}>Connecting to payment provider for <strong>{planId.toUpperCase()}</strong></p>
            </div>
          </div>
        ) : (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 24 }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', border: '1px solid rgba(200,146,42,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: 24 }}>🎵</span>
              </div>
              <div style={{ fontFamily: "'DM Sans', sans-serif" }}>
                <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 300, margin: '0 0 12px 0', color: '#FAF7F0' }}>
                  Online Payment Coming Soon
                </h3>
                <p style={{ fontSize: 14, color: 'rgba(250,247,240,0.5)', lineHeight: 1.7, margin: '0 0 8px 0' }}>
                  We're setting up secure online payments for the{' '}
                  <strong style={{ color: 'rgba(250,247,240,0.8)', textTransform: 'uppercase', fontSize: 12, letterSpacing: 2 }}>{planId}</strong> plan.
                </p>
                <p style={{ fontSize: 14, color: 'rgba(250,247,240,0.5)', lineHeight: 1.7, margin: '0 0 24px 0' }}>
                  In the meantime, please contact us directly — we'll get you set up right away.
                </p>
              </div>
              <a
                href="tel:+917313195517"
                style={{ width: '100%', padding: '16px', background: '#C8922A', border: 'none', color: '#fff', fontSize: 11, letterSpacing: '2px', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif", textDecoration: 'none', textAlign: 'center', display: 'block', marginBottom: 10 }}
              >
                Call Us: +91 73131 95517
              </a>
              <button
                onClick={() => window.location.href = '/'}
                style={{ width: '100%', padding: '14px', background: 'transparent', border: '1px solid rgba(200,146,42,0.3)', color: 'rgba(200,146,42,0.7)', fontSize: 11, letterSpacing: '2px', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif", cursor: 'pointer', transition: 'all 0.3s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(200,146,42,0.08)'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                Return to Homepage
              </button>
            </div>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
}
